import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { UserProvider } from './contexts/UserContext';
import { CartsProvider } from './contexts/CartContext';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <CartsProvider>
      <UserProvider>
        <App />
      </UserProvider>
      </CartsProvider>      
    </React.StrictMode>
  </BrowserRouter>
);

